module.exports = __webpack_public_path__ + "assets/ef886810db1ef2acee19a9a879876190.svg";